import pythonApiClient from './pythonBaseApi';

/**
 * Servicio para gestión de asignaciones Proyecto-Cliente
 * Maneja todas las operaciones relacionadas con la tabla pivot proyectos_clientes
 * 
 * NOTA: Los endpoints de asignaciones ahora usan Python (FastAPI)
 */
export const proyectoClienteApi = {
  /**
   * Obtiene todas las asignaciones proyecto-cliente
   * @returns {Promise} - Respuesta de la API
   */
  getAll: () => {
    // Usar endpoint de Python (FastAPI)
    return pythonApiClient.get('/proyecto-cliente');
  },

  /**
   * Obtiene los proyectos asignados a un cliente específico
   * @param {number} clienteId - ID del cliente
   * @returns {Promise} - Respuesta de la API
   */
  getProyectosByCliente: (clienteId) => {
    // Usar endpoint de Python (FastAPI)
    return pythonApiClient.get(`/clientes/${clienteId}/proyectos`);
  },

  /**
   * Obtiene los clientes asignados a un proyecto específico
   * @param {number} proyectoId - ID del proyecto
   * @returns {Promise} - Respuesta de la API
   */
  getClientesByProyecto: (proyectoId) => {
    // Usar endpoint de Python (FastAPI)
    return pythonApiClient.get(`/proyectos/${proyectoId}/clientes`);
  },

  /**
   * Asigna un proyecto a un cliente
   * @param {Object} data - Datos de la asignación
   * @param {number} data.id_cliente - ID del cliente
   * @param {number} data.id_proyecto - ID del proyecto
   * @returns {Promise} - Respuesta de la API
   */
  asignarProyecto: (data) => {
    // Usar endpoint de Python (FastAPI)
    return pythonApiClient.post('/proyecto-cliente/asignar', data);
  },

  /**
   * Desasigna un proyecto de un cliente
   * @param {Object} data - Datos de la desasignación
   * @param {number} data.id_cliente - ID del cliente
   * @param {number} data.id_proyecto - ID del proyecto
   * @returns {Promise} - Respuesta de la API
   */
  desasignarProyecto: (data) => {
    // Usar endpoint de Python (FastAPI)
    return pythonApiClient.post('/proyecto-cliente/desasignar', data);
  },

  /**
   * Actualiza todas las asignaciones de proyectos para un cliente
   * @param {number} clienteId - ID del cliente
   * @param {Object} data - Datos de actualización
   * @param {number[]} data.proyectos - Array de IDs de proyectos
   * @returns {Promise} - Respuesta de la API
   * 
   * NOTA: Este endpoint puede no estar disponible en Python. 
   * Si no funciona, usar asignar/desasignar individualmente.
   */
  updateAsignaciones: (clienteId, data) => {
    // Intentar usar endpoint de Python (FastAPI)
    // Si no existe, se puede implementar usando asignar/desasignar
    return pythonApiClient.put(`/clientes/${clienteId}/proyectos`, data);
  }
};

export default proyectoClienteApi;
